import React, { useEffect, useState } from 'react';
import { ChevronBackSharp } from 'react-ionicons';
import UsuarioLogo from '../assets/Usuario.svg';
import ContrasenaLogo from '../assets/Contrasena.svg';
import loginLogo from '../assets/loginIcon.png';
import env from 'react-dotenv';
import dotenv from 'dotenv';

import {
  TopBar,
  BoxLogin,
  LabelBLogin,
  CubeLogin,
} from '../component/Containers/Containers';
import { LAtrasButtom } from '../component/Buttons/Bottons';
import { InputLogin } from '../component/Inputs/Input';
import { setIsLoadingTo, setLoginStatus, setUserTo } from '../store/features/adminSlice';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';

const AboutButton = styled.button`
  position: relative;
  margin-top: 20px;
  width: 250px;
  height: 40px;
  outline: 0;
  background: #003876;
  border: none;
  border-radius: 8px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  overflow: hidden;
  transition: all ease-in 300ms;

  &:hover {
    background-color: #0b5ba3;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.6);
  }

  @media (max-width: 565px) {
    margin-top: 10px;
  }
`;

/**
 * returns the text that goes on the top bar of login page.
 * @returns {HTMLDivElement}
 */
const TopText = styled.div`
  font-weight: bold;
  font-size: 20px;
  width: 100%;
  z-index: 0;
  text-align: center;
  color: #fff;
  font-family: 'Montserrat';
`;

const BarDiv = styled.div`
  padding-left: 5px;
  float: left;
  z-index: 900;
  cursor: pointer;
`;

/**
 * @component
 * The login page accessed by /acerca-de-aplicacion
 * this allows the user to log in and be verified as Admin
 * in order to access editing and adding stations.
 * mutates the admin slice of state
 * @returns {void}
 */
const Login = () => {
  const loginUrl = env[`${process.env.REACT_APP_HOST_TYPE}-api`];
  const dispatch = useDispatch();

  const formRef1 = React.useRef(null);
  const formRef2 = React.useRef(null);

  /**
   * allows the use of the history object.
   */
  const nav = useHistory();

  /**
   * The url to verify the users against.
   */

  useEffect(() => {
    dispatch(setIsLoadingTo(false));
  }, [dispatch]);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  /**
   * doLogin takes care of login in for the user, compares the credentials
   * against the DB to verify authenticity of user.
   * @param {string} user
   * @param {string} pass
   * @returns {void}
   */
  const doLogin = async (user, pass) => {
    dispatch(setIsLoadingTo(true));
    const credentials = {
      Username: user.toLowerCase(),
      Password: pass,
    };

    try {
      if (formRef2.current.value.length === 0) {
        throw new Error('El campo de usuario esta vacio');
      }

      if (formRef1.current.value.length === 0) {
        throw new Error('El campo de contraseña esta vacio');
      }

      let data = await axios.post(loginUrl, credentials, {
        validateStatus: false,
      });
      console.log(data)
      dispatch(setUserTo(data))
      if (data.status === 200) {
        await dispatch(setLoginStatus(true));
        nav.push('/gestion-administrador');
      } else {
        throw new Error('informacion incorrecta');
      }
    } catch (e) {
      if (e.message.includes('usuario')) {
        Swal.fire({
          title: 'Error',
          text: 'Favor completar los campos requeridos',
          timer: 12000,
          icon: 'error',
          confirmButtonColor: '#003876',
        });
      } else if (e.message.includes('contraseña')) {
        Swal.fire({
          title: 'Error',
          text: 'Favor completar los campos requeridos',
          timer: 12000,
          icon: 'error',
          confirmButtonColor: '#003876',
        });
      }

      if (e.message.includes('informacion')) {
        Swal.fire({
          title: 'Error',
          text: 'Usuario o Contraseña incorrectos',
          timer: 12000,
          icon: 'error',
          confirmButtonColor: '#003876',
        });
      }
    } finally {
      dispatch(setIsLoadingTo(false));
    }
  };

  useEffect(() => {
    formRef1.current.focus();
    formRef1.current.blur();
    formRef2.current.focus();
    formRef2.current.blur();
  }, []);

  /**
   * Authoize invokes the doLogin method and passes the localstate
   * of username & password
   * @returns {void}
   */
  const Authorize = () => {
    doLogin(username, password);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    Authorize();
  };

  return (
    <>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}>
        <TopBar style={{ display: true }}>
          <TopText>RADIO CTC</TopText>
          <BarDiv>
            <LAtrasButtom
              onClick={() => nav.push('/acerca-de-aplicacion')}
              style={{
                position: 'absolute',
                top: 7,
                left: 25,
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}>
              <ChevronBackSharp
                onClick={() => nav.push('/acerca-de-aplicacion')}
                style={{
                  position: 'absolute',
                  left: 1,
                  paddingTop: '1',
                  top: '4px',
                }}
                height="35px"
                width="35px"
                color={'#fff'}
              />
              <span
                style={{
                  paddingLeft: '30px',
                  fontSize: '18px',
                  display: 'block',
                  paddingTop: '28px',
                }}>
                Atrás
              </span>
            </LAtrasButtom>
          </BarDiv>
        </TopBar>
        <CubeLogin>
          <section
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <img
              alt="ctc radio logo"
              src={loginLogo}
              style={{ marginBottom: '10%', height: 'auto', width: '40%' }}
            />
          </section>
          <form
            onSubmit={(e) => handleSubmit(e)}
            autoComplete="nope"
            style={{ marginLeft: '10px' }}>
            <BoxLogin>
              <InputLogin
                ref={formRef2}
                autoComplete="nope"
                type="text"
                placeholder="Usuario"
                placeholderTextColor="#000"
                name="Usuario"
                readonly
                onChange={(event) => setUsername(event.target.value)}
              />
              <LabelBLogin>
                <img src={UsuarioLogo} width="30px" height="30px" />
              </LabelBLogin>
            </BoxLogin>
            <BoxLogin>
              <InputLogin
                ref={formRef1}
                autoComplete="nope"
                type="password"
                placeholder="Contraseña"
                value={password}
                name="password"
                onChange={(event) => setPassword(event.target.value)}
              />
              <LabelBLogin>
                <img src={ContrasenaLogo} width="30px" height="30px" />
              </LabelBLogin>
            </BoxLogin>

            <div
              style={{
                width: '100%',
                margin: 0,
                padding: 0,
                display: 'flex',
                justify: 'center',
                alignItems: 'center',
              }}>
              <AboutButton style={{ margin: 'auto' }} type="submit">
                ACCEDER
              </AboutButton>
            </div>
          </form>
        </CubeLogin>
      </div>
    </>
  );
};

export default Login;
